import { OP } from "../../constant";

// ------------- > AGENT ACTIONS < ----------- //
// agent list
export function fetchAgentRequest(token) {
  return {
    type: OP.AGENT_LIST_REQUEST,
    payload: {
      token,
    },
  };
}

export function fetchAgentReset() {
  return {
    type: OP.AGENT_LIST_RESET,
  };
}

// add agent
export function addAgentRequest(token, data) {
  return {
    type: OP.ADD_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function addAgentReset() {
  return {
    type: OP.ADD_AGENT_RESET,
  };
}

// view agent
export function viewAgentRequest(token, data) {
  return {
    type: OP.VIEW_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewAgentReset() {
  return {
    type: OP.VIEW_AGENT_RESET,
  };
}

// edit agent
export function editAgentRequest(token, data) {
  return {
    type: OP.EDIT_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function editAgentReset() {
  return {
    type: OP.EDIT_AGENT_RESET,
  };
}

// activate agent
export function activateAgentRequest(token, data) {
  return {
    type: OP.ACTIVATE_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function activateAgentReset() {
  return {
    type: OP.ACTIVATE_AGENT_RESET,
  };
}

// deactivate agent
export function deactivateAgentRequest(token, data) {
  return {
    type: OP.DEACTIVATE_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deactivateAgentReset() {
  return {
    type: OP.DEACTIVATE_AGENT_RESET,
  };
}

// approve agent
export function approveAgentRequest(token, data) {
  return {
    type: OP.APPROVE_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function approveAgentReset() {
  return {
    type: OP.APPROVE_AGENT_RESET,
  };
}

// reject agent
export function rejectAgentRequest(token, data) {
  return {
    type: OP.REJECT_AGENT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function rejectAgentReset() {
  return {
    type: OP.REJECT_AGENT_RESET,
  };
}

// reject agent
export function getAgentDetailsRequest(token, data) {
  return {
    type: OP.GET_AGENT_DETAILS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getAgentDetailsReset() {
  return {
    type: OP.GET_AGENT_DETAILS_RESET,
  };
}

// agent commission summary
export function getAgentCommissionSummaryRequest(token, data) {
  return {
    type: OP.AGENT_COMMISSION_SUMMARY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getAgentCommissionSummaryReset() {
  return {
    type: OP.AGENT_COMMISSION_SUMMARY_RESET,
  };
}

// agent commissions list
export function getAgentCommissionsRequest(token, data) {
  return {
    type: OP.AGENT_COMMISSIONS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getAgentCommissionsReset() {
  return {
    type: OP.AGENT_COMMISSIONS_RESET,
  };
}

// agent commissions by date
export function getAgentCommissionsByDateRequest(token, data) {
  return {
    type: OP.AGENT_COMMISSIONS_BY_DATE_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getAgentCommissionsByDateReset() {
  return {
    type: OP.AGENT_COMMISSIONS_BY_DATE_RESET,
  };
}
